import React, { Component } from 'react'
import { View, StyleSheet } from 'react-native'

import ActionWrapper from './ActionWrapper'

export default class Group extends Component {
  render() {
    let { object, children, component, styleOverrides } = this.props

    return (
      <ActionWrapper
        component={component}
        object={object}
        style={[styles.group, styleOverrides]}
      >
        <View style={styles.group} pointerEvents="box-none">
          {children}
        </View>
      </ActionWrapper>
    )
  }
}

const styles = StyleSheet.create({
  group: {
    flex: 1,
  },
})
